import React from 'react'
import { FileCode2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { NmsConfigurationList } from '@/components/nms/NmsConfigurationList'

interface NmsProjectTabProps {
  projectId: string
}

export const NmsProjectTab: React.FC<NmsProjectTabProps> = ({ projectId }) => {
  const { t } = useTranslation()
  return (
    <div className="space-y-4">
      <div>
        <h2 className="flex items-center gap-2 text-lg font-semibold text-slate-900 dark:text-white">
          <FileCode2 className="h-5 w-5 text-blue-700" />
          {t('nms.vesselTitle')}
        </h2>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          {t('nms.vesselSubtitle')}
        </p>
      </div>
      <NmsConfigurationList projectId={projectId} />
    </div>
  )
}
